import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IServiceOperation } from '../../../models/index';
import { IServiceOperationNameResponse } from '../../actions/types/services/CurrentServiceOpsFormTypes';

/**
 Initial data
 */
const initialState: IServiceOperationNameResponse = {
  currentServiceOperationFormData: {
    serviceOperation: '',
    operationUrl: '',
    operationVerb: '',
    queryPathParam: [{ key: '', value: ' ' }],
    headerParam: [{ key: '', value: ' ' }]
  }
};
const currentServiceOperationForm = createSlice({
  name: 'currentServiceOperationForm',
  initialState,
  reducers: {
    addCurrentServiceOperation: (
      state,
      action: PayloadAction<IServiceOperation>
    ) => {
      state.currentServiceOperationFormData = action.payload;
    },
    deleteCurrentServiceOperation: (state) => {
      state.currentServiceOperationFormData = initialState.currentServiceOperationFormData;
    }
  }
});
export const { addCurrentServiceOperation, deleteCurrentServiceOperation } = currentServiceOperationForm.actions;
export default currentServiceOperationForm.reducer;
